import React from "react";
import NavbarComponent from "./Navbar";
import Footer from "../Footer";
import AboutUsBanner from "./AboutUsBanner";
import CommitmentSection from "../CommitmentSection";
import AchievementSection from "./AchievementSection";
import MissionVisionSection from "./MissionVisionSection";

const AboutUsPage = () => {
  return (
    <>
      <NavbarComponent />
      <AboutUsBanner/>
      <CommitmentSection/>
      <MissionVisionSection/>
     
      <AchievementSection/>
       <Footer /> 
    </>
  );
};

export default AboutUsPage;
